
const formList = {
    drugReport: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "patName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "患者名称",
        },
    ],
    //待提交页面
    drugInformation: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        // {
        //     entityField: "wfdName",
        //     fieldType: "string",
        //     formatterContent: null,
        //     isRequired: 0,
        //     isShow: 1,
        //     searchId: "",
        //     extractId: null,
        //     setField: '',
        //     showField: "审批流名称",
        // },
    ],
    drugGybhgAuditList: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            showField: "审批状态",
            entityField: "state",
            isShow: 1,
            fieldType: "select",
            searchId: null,
            formatterContent: [
                {
                    key: "全部",
                    value: '',
                },
                {
                    key: "0",
                    value: "待审批",
                },
                {
                    key: "1",
                    value: "已审批",
                },

            ],
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "商品名称",
            entityField: "itemname",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
         {
            showField: "批号",
            entityField: "batchnbr",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
          {
            showField: "任务号",
            entityField: "audittasknumber",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
    ],
    drugGyycshAuditList: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            showField: "商品名称",
            entityField: "drugname",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
         {
            showField: "批号",
            entityField: "lotno",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
          {
            showField: "易明订单号",
            entityField: "ownbillno",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "供应商",
            entityField: "supplier",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
    ],
}
export default formList